const state = {
    sectors: [],
    category: [],
    sub_category: [],
    sub_sub_category: [],
    sec_pred: [],
    cat_pred: [],
    mailing_type_pred: [],
    sec_company_pred: [],
    raw_data: '',
    sectorsData: [],
    company_img_data: [],
    current_company_id: '',
    current_company_path: '',
    last_worked_user: '',
    company_associated_data: [],
    data: {
        index_name: '',
        product_id: '',
        publication: [],
        observed_traffic_source: '',
        dm_tm_source: '',
        muid: '',
        userid: '',
        email_subject: '',
        isMobile: '',
        isprescreen: false,
        group_size: [],
        face_amount: [],
        term_length: [],
        issue_type: [],
        riders: [],
        panelists: [],
        state_specific: false,
        entrydate: new Date().toISOString().substr(0, 10),
        offer_expiry_date: '',
        varient_entry_id: '',
        varient_type: [],
        companies: [],
        product_image: '',
        product_img: '',
        affinity: [],
        media_chan: '',
        audience: '',
        sectors: [],
        // category: '',
        // subcategory: '',
        // subsubcategory: '',
        offer_origin: '',
        product_name: '',
        product_headline: '',
        worktype_voluntary: '',
        prescreen_opnotice: '',
        fee_product: '',
        faux_check: '',
        tip_on_card: "",
        handwriting: "",
        prescription: '',
        is_hphsa: '',
        ancilary_products: [],
        response_mechanism: [],
        business_content: 0,
        personalization: 2,
        mailing_type: '',
        communication_type: [],
        sign_on_1: {
            sign_on_incentive: '',
            ongoing_incentive: '',
            sign_on_incentive_type: 0,
            sign_on_incentive_value: '',
            sign_on_acceleretor_per: '',
            sign_on_acceleretor_type: 0,
            sign_on_max_award: '',
            sign_on_incentive_max_spend: '',
            sign_on_incentive_min_spend: '',
            sign_on_incentive_window_month: '',
            sign_on_limit_specific_category: '',
            sign_on_fixed_date: '',
        },
        sign_on_2: {
            sign_on_incentive: '',
            sign_on_incentive_type: 0,
            sign_on_incentive_value: '',
            sign_on_acceleretor_per: '',
            sign_on_acceleretor_type: 0,
            sign_on_max_award: '',
            sign_on_incentive_max_spend: '',
            sign_on_incentive_min_spend: '',
            sign_on_incentive_window_month: '',
            sign_on_limit_specific_category: '',
            sign_on_fixed_date: '',
        },
        sign_on_3: {
            sign_on_incentive: '',
            sign_on_incentive_type: 0,
            sign_on_incentive_value: '',
            sign_on_acceleretor_per: '',
            sign_on_acceleretor_type: 0,
            sign_on_max_award: '',
            sign_on_incentive_max_spend: '',
            sign_on_incentive_min_spend: '',
            sign_on_incentive_window_month: '',
            sign_on_limit_specific_category: '',
            sign_on_fixed_date: '',
        },
        campaign_language: 1,
        target_market: [],
        state_province: [],
        primary_country: '',
        gender: '',
        age: [],
        income: [],
        citi: 0,
        // on_home_page: '',
        // high_priority: '',
        banking: {
            reward_program_emphasis: '',
            reward_program: '',
            card_type: '',
            debit_card_mentioned: '',
            cd_apy: '',
            cd_apr: '',
            money_market_apy: '',
            money_market_apr: '',
            saving_apy: '',
            saving_apr: '',
            checking_apy: '',
            checking_apr: '',
            free_checking: '',
            minimum_deposit: '',
        },
        credit_card: {
            promotional_offer: false,
            tier_1_balance_transfer_introduction_apr: '',
            tier_1_balance_transfer_introductory_period: '',
            tier_2_balance_transfer_introduction_apr: '',
            tier_2_balance_transfer_introductory_period: '',
            // balance_transfer_introductory_maximum_fee: '',
            PromotionalOfferUsageFee: '',
            tier_2_balance_transfer_introductory_usage_fee: '',
            PromotionalOfferMaximumFee: '',
            PromotionalOfferMinimumFee: '',
            tier_2_balance_transfer_introductory_minimum_fee: '',
            balance_transfer_introductory_fee_period: '',
            tier_1_cash_advance_introductory_apr: '',
            tier_1_cash_advance_introductory_period: '',
            tier_2_cash_advance_introductory_apr: '',
            tier_2_cash_advance_introductory_period: '',
            cash_advance_introductory_usage_fee: '',
            cash_advance_introductory_minimum_fee: '',
            cash_advance_introductory_maximum_fee: '',
            cash_advance_introductory_fee_period: '',

            tier_1_purchase_introductory_apr: '',
            tier_1_purchase_introductory_period: '',
            tier_2_purchase_introductory_apr: '',
            tier_2_purchase_introductory_period: '',
            purchase_introductory_usage_fee: '',
            purchase_introductory_minimum_fee: '',
            purchase_introductory_maximum_fee: '',
            purchase_introductory_fee_period: '',
            balance_transfer_regular_apr: '',
            balance_transfer_regular_rate_type: '',
            balance_transfer_usage_fee: '',
            balance_transfer_minimum_fee: '',
            balance_transfer_maximum_fee: '',
            cash_advance_regular_apr: '',
            cash_advance_regular_rate_type: '',
            cash_advance_usage_fee: '',
            cash_advance_minimum_fee: '',
            cash_advance_maximum_fee: '',
            perchase_regular_apr: '',
            perchase_regular_rate_type: '',
        },
        delivery: {
            delivery_method: '',
            delivery_type: '',
            postage: '',
            pre_sorted: '',
            package_type: '',
        },
        energy: {
            offer_price_per_kwh: '',
            offer_price_per_kwh2: '',
            offer_price_per_kwh3: '',
            offer_price_per_kwh4: '',
            term_length: '',
            term_length2: '',
            term_length3: '',
            term_length4: '',
            cancel_fee: '',
            cancel_fee_details: '',
            rate_type: '',
            rate_type2: '',
            rate_type3: '',
            rate_type4: '',
        },
        media_channel: {
            electronic_type: '',
            digital_source: '',
            number_updates_tweets: '',
            number_fans_followers: '',
            external_link: '',
            social_media_add_type: '',
        },
        mortgage_loans: {
            refinance: '',
            jumbo_non_conforming: '',
            va: '',
            fha: '',
            conventional: '',
            usda: '',
            correspondent_lending: '',
            application_type: '',
            offered_loan_amount: '',
            maximum_loan_amount: '',
            minimum_loan_amount: '',
            loan_term_months: '',
            offered_apr: '',
            upper_apr: '',
            lower_apr: '',
            rate_type: '',
            introductory_apr: '',
            introductory_period_months: '',
        },
        payment_card: {
            application_type: '',
            card_network: '',
            primary_card_level: '',
            secondary_card_level: '',
            reward_program: '',
            reward_program_emphasis: '',
            reward_program_rate: '',
            reloadable: '',
            tier_1_purchase_regular_apr: '',
            tier_2_purchase_regular_apr: '',
            tier_3_purchase_regular_apr: '',
            purchase_regular_apr_detail: '',
            perchase_regular_rate_type: '',
            tier_1_balance_transfer_regular_apr: '',
            tier_2_balance_transfer_regular_apr: '',
            tier_3_balance_transfer_regular_apr: '',
            balance_transfer_regular_apr_detail: '',
            balance_transfer_regular_rate_type: '',
            PenaltyAPR: '',
            PenaltyAPRDetails: '',
            tier_1_annual_fee: '',
            tier_2_annual_fee: '',
            tier_3_annual_fee: '',
            annual_fee_details: '',
            tier_1_late_fee: '',
            tier_2_late_fee: '',
            tier_3_late_fee: '',
            late_fee_details: '',
            tier_1_overlimit_fee: '',
            tier_2_overlimit_fee: '',
            tier_3_overlimit_fee: '',
            overlimit_fee_details: '',
            balance_transfer_usage_fee: '',
            balance_transfer_minimum_fee: '',
            balance_transfer_maximun_fee: '',
            cash_advance_usage_fee: '',
            cash_advance_minimum_fee: '',
            cash_advance_maximum_fee: '',
            minimum_card_limit: '',
            maximum_card_limit: '',
            MonthlyMaintenanceFee:'',
            StandardMonthlyMaintenanceFee:'',
            purchase_introductory_apr: '',
            purchase_introductory_period_months: '',
            balance_transfer_introductory_apr: '',
            balance_transfer_introductory_period_months: '',
            balance_transfer_introductory_usage_fee: '',
            balance_transfer_introductory_minimum_fee: '',
            balance_transfer_introductory_maximum_fee: '',
            balance_transfer_introductory_fee_period_months: '',
            balance_transfer_introductory_fee_details: '',
            cash_advance_introductory_apr: '',
            cash_advance_introductory_period_months: '',
            cash_advance_introductory_usage_fee: '',
            cash_advance_introductory_minimum_fee: '',
            cash_advance_introductory_maximum_fee: '',
            cash_advance_introductory_fee_period_months: '',
            cash_advance_introductory_fee_details: '',
            tier_1_cash_advance_regular_apr: '',
            tier_2_cash_advance_regular_apr: '',
            tier_3_cash_advance_regular_apr: '',
            cash_advance_regular_apr_details: '',
            cash_advance_regular_rate_type: '',
            promotional_purchase_pricing_usage_offer: '',
            promotional_purchase_pricing_usage_offer_months: ''
        },
        retail: {
            credit_card_mentioned: '',
        },
        telecom: {
            plan_featured: '',
            featured_plan_name: '',
            contract_required: '',
            internet_speed: '',
            monthly_cost: '',
            lower_featured_monthly_cost: '',
            upper_featured_monthly_cost: '',
            activation_charge: '',
            installation_charge: '',
            local_calling_monthly_charge: '',
            // local_distance_monthly_charge: '',
            long_distance_monthly_charge: '',
            introductory_cost: '',
            introductory_period_months: '',
        },
        travel: {
            debit_card_mentioned: '',
            credit_card_mentioned: '',
            credit_network: [],
        },
        advertiser: {
            address: '',
            city: '',
            state_province: null,
            zipcode: '',
            phone: '',
            url: ''
        },
        promotions: [],
        promotion_other_fields: {
            holiday: null,
            sale_type: null,
        },
        product_status: '',
        product_comment: '',
        is_addproduct: '',
        ec_content_type: null,
        pdf_content: '',
        current_pdf: '',
        banner_product_path: '',
        entry_id: '',
        entry_date_changed: false,
        mobile_digital_file_type: '',
        mobile_digital_file_url: '',
        mobile_digital_file_size: '',
        document_size_byte: '',
        original_document_size: '',
        medial_channel_name: '',
        is_mobile: '',
        file_name: '',
        pdf_cdn_link: '',
        pdf_cdn_link_orig: '',
        is_deleted: '',
        direct_mail_logfile: '',
        added_to_database: '',

    }
}

export default state
